import { Container } from 'inversify'

import {
  ParticipantSubType,
  SoccerLineupPositions,
} from '@collector/sportsapi-client-legacy'
import { RelationSportCommonIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportCommonDependencies'

export function bindLineupsConfiguration(ioc: Container): void {
  ioc
    .bind(RelationSportCommonIoCBindings.LineupsConfiguration)
    .toDynamicValue(() => {
      return {
        availablePositions: [
          {
            name: 'Goalkeeper',
            acronym: 'GK',
            canCaptainBeSelected: true,
            canNumberBeAssigned: true,
            subtypes: [
              ParticipantSubType.Athlete,
              ParticipantSubType.AthleteCoach,
            ],
            button: { color: 'blue' },
            maximumPlayersAmount: 1,
            parentPositionTypeName: '1st lineup',
          },
          {
            name: '1st lineup',
            acronym: '1ST',
            canCaptainBeSelected: true,
            canNumberBeAssigned: true,
            subtypes: [
              ParticipantSubType.Athlete,
              ParticipantSubType.AthleteCoach,
            ],
            button: { color: 'green' },
            maximumPlayersAmount: 11,
          },
          {
            name: 'Bench',
            acronym: 'BEN',
            canCaptainBeSelected: false,
            canNumberBeAssigned: true,
            subtypes: [
              ParticipantSubType.Athlete,
              ParticipantSubType.AthleteCoach,
            ],
            button: { color: 'orange' },
          },
          {
            name: 'Coach',
            acronym: 'COA',
            canCaptainBeSelected: false,
            canNumberBeAssigned: false,
            subtypes: [
              ParticipantSubType.Athlete,
              ParticipantSubType.AthleteCoach,
              ParticipantSubType.Coach,
            ],
            button: { color: 'gray' },
          },
        ],
        lineupPositionOrder: [
          SoccerLineupPositions.Goalkeeper,
          SoccerLineupPositions.Defender,
          SoccerLineupPositions.Midfielder,
          SoccerLineupPositions.Attacker,
          SoccerLineupPositions.Unknown,
          SoccerLineupPositions.NoPosition,
        ],
      }
    })
    .inSingletonScope()
}
